import axios from 'axios';
import config from '../../../config/sbf_config';

let baseUrl = config.backendUrl;

if (process.env.SETTINGS !== undefined) {
    if (process.env.SETTINGS === 'test' || process.env.SETTINGS === 'staging') {
        baseUrl = 'https://staging.connect.superbikefactory.co.uk/';
    }

    if (process.env.SETTINGS === 'preprod') {
        baseUrl = 'https://connect-preprod.superbikefactory.co.uk/';
    }
}

export const uploadImage = async ({
    _id, kind,
    picture,
    blemish_report_question,
}) => {
    let res;
    try {
        res = await axios.post(
            `${baseUrl}upload/image`,
            {
                _id,
                kind,
                picture,
                blemish_report_question,
            },
        ).then((response) => response.data);
    } catch (e) {
        res = {
            result: false,
            error: {
                message: e.message,
            },
        };
    }
    return res;
};



// WEBPACK FOOTER //
// ./src/modules/App/requests/upload_image_request.js